document.querySelectorAll('enquiry-form .enquiry-form__form').forEach(form => {
  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const wrapper = form.closest('enquiry-form');
    const errorEl = wrapper?.querySelector('.enquiry-form__error');

    const missing = [...form.querySelectorAll('[required]')].filter(el => !el.value.trim());
    if (missing.length) {
      if (errorEl) errorEl.textContent = 'Please complete all required fields.';
      missing[0].focus();
      return;
    }
    if (errorEl) errorEl.textContent = '';

    const btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }

    const get = (name) => form.querySelector(`[name="${name}"]`)?.value?.trim() ?? '';

    const firstName = get('contact[first_name]');
    const lastName  = get('contact[last_name]');
    const email     = get('contact[email]');
    const phone     = get('contact[phone]');
    const country   = get('contact[country]');
    const nature    = get('contact[nature_of_enquiry]');
    const piece     = get('contact[piece_of_interest]');
    const message   = get('contact[body]');

    const bodyLines = [
      `First Name: ${firstName}`,
      `Last Name: ${lastName}`,
      phone ? `Phone: ${phone}` : null,
      `Country: ${country}`,
      `Nature of Enquiry: ${nature}`,
      piece ? `Piece of Interest: ${piece}` : null,
      `\nMessage:\n${message}`,
    ].filter(Boolean).join('\n');

    const body = new URLSearchParams({
      form_type: 'contact',
      utf8: '✓',
      'contact[name]': `${firstName} ${lastName}`,
      'contact[email]': email,
      'contact[body]': bodyLines,
    });

    try {
      await fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
        redirect: 'manual',
      });

      form.hidden = true;
      const success = wrapper?.querySelector('.enquiry-form__success');
      if (success) success.hidden = false;
    } catch {
      if (errorEl) errorEl.textContent = 'Something went wrong — please try again.';
      if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
    }
  });
});
